<template>
  <v-container fill-height fluid grid-list-lg class="py-2 px-3">
    <v-layout row wrap>
      <v-flex xs12 md4 lg3>
        <v-card style="height: 100%;width: 100%;">
          <!--<v-card-title class="pa-0">-->
            <v-system-bar color="accent" dark window>
              <v-toolbar-title>Комплексные статистики</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn small icon @click="addStatistic" class="mx-0"><v-icon class="mx-0">add</v-icon></v-btn>
            </v-system-bar>
          <!--</v-card-title>-->
          <v-card-text class="statistics-list">
            <v-list dense class="statistics-list__item">
              <v-list-tile v-if="complex_statistics.length===0">
                <v-list-tile-title>Статистики данного типа отсутствуют</v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-else v-for="(item, index) in complex_statistics" :key="item.id" @click="getStatistic(item.id)" class="set__list-item"
                           :class="{'blue lighten-4':item.id===selectedStatistic}">
                <v-list-tile-content>
                  <v-list-tile-title @contextmenu.prevent="openCtxMenu(item)">{{item.name}}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card-text>
          
          
        </v-card>
      </v-flex>
      
      <v-flex xs12 md8 lg9>
        <v-card>
          <v-system-bar color="accent" dark window>
            <v-icon>mdi-chart-line</v-icon>
            <v-toolbar-title class="ml-1">Статистика</v-toolbar-title>
          </v-system-bar>
          <v-flex xs12 v-if="selectedStatistic">
            <v-flex xs12 class="text-xs-center" v-if="loaded">
              <template v-if="mode==='table'">
                <div class="text-xs-center my-3">
                  <span class="pull-left" v-if="this.statistic.unit">Ед. изм. : {{this.statistic.unit}}</span>
                  <span class="title blue-grey--text">{{this.statistic.name}}</span>
                  <v-btn small class="pull-right blue-grey white--text" @click="getStatistic(selectedStatistic)">График</v-btn>
                </div>
                
                <v-data-table
                  :headers="headers"
                  :items="items"
                  hide-actions
                  no-data-text="Данные не введены"
                  class="statistic-data-table"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-center"> {{ props.item.name }} </td>
                    <td class="text-xs-center" v-for="(el, index) in props.item.data" :key="index">{{el.value}}</td>
                  </template>
                </v-data-table>
              </template>
              <d-statistic v-else :statistic="statistic" :height="7/16*100+'%'" with_periods with_table :sets="sets" @change-period="changePeriod($event)" @table-view="tableMode"></d-statistic>
            </v-flex>
            <v-flex xs12 class="text-xs-center pt-5" v-else>
              <p>Загрузка ...</p>
              <v-progress-circular :size="70" :width="7" indeterminate color="primary"></v-progress-circular>
            </v-flex>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
    
    <v-dialog v-model="dialog" max-width="1000" scrollable persistent>
      <component :is="currentComponent" v-if="dialog" v-bind="formProps" @close-dialog="dialog=false" @save="saveChanges"></component>
    </v-dialog>
  
    <context-menu id="statistics-context-menu" ref="ctxMenu">
      <li @click="infoStatistic"><v-icon size="18">mdi-information</v-icon> Информация</li>
      <li @click="editStatistic" v-if="currentNode && currentNode.can_edit"><v-icon size="18">mdi-pencil</v-icon> Редактировать</li>
      <li @click="deleteStatistic" v-if="currentNode && currentNode.can_edit"><v-icon size="18">mdi-delete</v-icon> Удалить</li>
    </context-menu>
    
  </v-container>
</template>

<script>
  const uuidRegexpPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
  import DStatistic from './Statistic'
  import ComplexStatisticForm from './Forms/ComplexStatisticForm'
  import contextMenu from 'vue-context-menu'
  
  import {mapGetters} from 'vuex'
  
  export default {
    name : 'StatisticsList',
    
    components:{
      DStatistic,
      contextMenu
    },
    
    data(){
      return{
        formProps: {},
        dialog: false,
        loaded: false,
        selectedStatistic: null,
        currentComponent: null,
        currentNode: null,
        mode: 'graph',
        headers: [],
        items: [],
      }
    },
    
    computed:{
      headers_fill(){
        return [{
          text: 'Дата',
          align: 'center',
          sortable: false,
          class: 'data-table-header',
          width: 120
        }].concat(this.label_objects)
      },
      accesses(){
        return this.$store.state.app.account.accesses['analytics'] || {}
      },
      ...mapGetters('analytics_old/sets', ['sets']),
      ...mapGetters('analytics_old/statistics', ['complex_statistics']),
      ...mapGetters('app/org', ['getPostById', 'getContainerById']),
    },
    
    created(){
      this.$store.dispatch('analytics_old/statistics/list')
      this.$store.dispatch('analytics_old/sets/list')
      if(this.$route.query.id){
        this.tableMode(this.$route.query.id)
      }
    },
    
    methods: {
      openCtxMenu(item) {
        this.currentNode = item
        this.$refs.ctxMenu.open()
      },
      
      changePeriod(data){
        this.getStatistic(data.id, data.period_type)
      },
      
      getStatistic(id, period){
        let parameters = {}
        if ( typeof period !== 'undefined' ){
          parameters = { period_type: period}
        }
        this.mode = 'graph'
        this.loaded = false
        this.selectedStatistic = id
        this.$store.dispatch('analytics_old/statistics/getData', {id: id, type: 'statistic', mode:'graph', data: parameters }).then( response => {
          this.statistic = response
          this.statistic.entity_type = 'statistic'
          this.loaded = true
  
          let posts = []
          let containers = []
  
          this.statistic.lines.map(set=>{
            let name = ''
            set.label_name = '<b><i>'+set.label_name+': </i></b>'
            set.line.map( (item,index) => {
              let temp = ''
              if(item.type===1){
                temp = '<i aria-hidden="true" class="v-icon mdi mdi-sigma" style="font-size:19px"></i>('
              }
              item.objects.map( (obj, ind) => {
                obj.name = obj.identified
                if(obj.element_type==='post'){
                  let post = this.getPostById(obj.identified)
                  if(post.loaded){
                    obj.name = post.name
                  } else if(!posts.includes(obj.identified)){
                    posts.push(obj.identified)
                  }
                } else if(obj.element_type==='container'){
                  let container = this.getContainerById(obj.identified)
                  if(container.loaded){
                    obj.name = container.name
                  } else if(!containers.includes(obj.identified)){
                    containers.push(obj.identified)
                  }
                }
                let sep = (ind===item.objects.length-1) ? '' : '->'
                temp= temp + obj.name + sep
              })
              if(item.type===1) temp+=')'
              if(index!==set.line.length-1){
                temp+='<i aria-hidden="true" class="v-icon mdi mdi-ampersand" style="font-size:17px"></i>'
              }
              name+=temp
            })
            set.name = set.label_name + name
          })
  
          if(posts.length>0 || containers.length>0){
            this.$store.dispatch('app/org/entitiesInfo', { posts, containers }).then( response => {
              //Запись постов в хранилище, чтобы не запрашивать при возможной отрисовке следующей таблицы
              this.$store.commit('app/org/addPosts', response.posts_data)
              this.$store.commit('app/org/addContainers', response.containers_data)
              //Парсинг имен объектов и замена uuid на соответствующее название поста
              setting.map(set=>{
                let name = ''
                set.line.map( (item,index) => {
                  let temp = ''
                  if(item.type===1){
                    temp = '<i aria-hidden="true" class="v-icon mdi mdi-sigma" style="font-size:19px"></i>('
                  }
                  item.objects.map( (obj, ind) => {
                    if(obj.element_type==='post'){
                      let post = this.getPostById(obj.identified)
                      if(post.loaded){
                        obj.name = post.name
                      } else {
                        obj.name = 'Неизвестный объект'
                      }
                    } else if(obj.element_type==='container'){
                      let container = this.getContainerById(obj.identified)
                      if(container.loaded){
                        obj.name = container.name
                      } else {
                        obj.name = 'Неизвестный объект'
                      }
                    }
                    let sep = (ind===item.objects.length-1) ? '' : '->'
                    temp= temp + obj.name + sep
                  })
                  if(item.type===1) temp+=')'
                  if(index!==set.line.length-1){
                    temp+='<i aria-hidden="true" class="v-icon mdi mdi-ampersand" style="font-size:17px"></i>'
                  }
                  name+=temp
                })
                set.name = set.label_name + name
              })
            })
          }
        })
      },
  
      infoStatistic(){
        this.$root.$info('Информация о статистике', this.currentNode.description).then( )
      },
  
      addStatistic(){
        this.formProps = {}
        this.currentComponent = ComplexStatisticForm
        this.dialog = true
      },
      
      editStatistic(){
        this.formProps = {  data: this.currentNode, editMode: true }
        this.currentComponent = ComplexStatisticForm
        this.dialog = true
      },
      
      deleteStatistic(){
        this.$dmsAgree({message: 'Вы уверены, что хотите удалить выбранный элемент?', title: 'Удаление статистики'}).then( confirm => {
          this.$store.dispatch('analytics_old/statistics/delete', this.currentNode.id)
        })
      },
      
      saveChanges(eventData){
        this.dialog = false
      },
      
      tableMode(id){
        this.mode = 'table'
        this.loaded = false
        this.selectedStatistic = id
        this.$store.dispatch('analytics_old/statistics/getData', {id: id, type:'statistic', mode: 'table', data: {} }).then( response => {
          this.loaded = true
          this.statistic = response.statistic
          this.headers = [{
            text: 'Объект',
            sortable: false,
            align: 'center',
            class: 'stat-table-header'
          }]
          response.dates.forEach( item => {
            this.headers.push({
              text: item,
              sortable: false,
              align: 'center',
              class: 'stat-table-header'
            })
          })
          
          this.items = []
          response.statistic.lines.forEach( item => {
            let temp = {}
            temp.name = item.name
            temp.data = []
            
            response.dates.forEach( obj => {
              const index = item.data.findIndex( el => el.date === obj )
              if( index > -1 ) temp.data.push( { value : item.data[ index ].value, date : obj } )
              else temp.data.push( { value : '', date : obj } )
            })
            this.items.push( temp )
          })
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .stat-table-header{
    white-space: normal !important;
    width: 60px !important;
  }
  .statistic-data-table table.table td, .statistic-data-table table.table thead tr:first-child th{
    height: 30px !important;
    padding: 0 8px !important;
  }
  .statistic-data-table table.table thead tr {
    height: 30px;
  }
  
  #statistics-context-menu ul.ctx-menu li{
    padding: 6px 7px 6px 10px;
    cursor: pointer;
    font-size: 14px;
  }
  #statistics-context-menu ul.ctx-menu li:hover{
    background: #e4e4e4;
  }
  #statistics-context-menu ul.ctx-menu li i{
    width: 20px;
  }
  .statistics-list{
    height: calc(100% - 48px);
    width: 100%;
    position: relative;
  &__item{
     position: absolute;
     top: 0;
     left: 0;
     width: 100%;
     height: 100%;
     overflow: auto;
   }
  }
</style>


// WEBPACK FOOTER //
// src/apps/analytics_old/components/Statistics/Complex.vue